import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-GreenDot",
  "use": "icon-GreenDot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-GreenDot\"><path d=\"M512 624a112 112 0 1 0 0-224 112 112 0 0 0 0 224z\" p-id=\"2762\" fill=\"#1afa29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol